export const readTextArr = [
  "会议记录是思想的足迹，是智慧的交锋，是决策的见证，是行动的指南，是永恒的宝藏",
  "记录是时光的备忘录，让每一次智慧的交锋都能清晰存档，让每一个睿智的决策都有迹可循",
  "会议是集思广益的精神盛宴，是解决问题的关键环节，一次高效的会议，胜过无数次盲目的行动",
  "没有记录就没有发生，留存每一次讨论的热度，不遗漏每一个创新的火花，用记录构建我的第二大脑",
];
